function localityList() {
    var lists = {
        "data": {
            "TUNIS": [
                "EL MEDINA",
                "BAB BHAR",
                "SIDI EL BECHIR",
                "SIJOUMI",
                "BAB SOUIKA",
                "EL OMRANE",
                "EL MENZAH",
                "EL OUARDIA",
                "JEBEL JELOUD",
                "EL HRAIRIA",
                "OMRANE SUPERIEUR",
                "BARDO",
                "LA GOULETTE",
                "LA MARSA",
                "KABARIA",
                "SIDI HASSINE",
                "CITE EL KHADRA",
                "CARTHAGE",
                "TAHRIR",
                "EZZOUHOUR",
                "EL KRAM"
            ],
            "ARIANA": [
                "ARIANA VILLE",
                "KALAAT EL ANDALOUS",
                "SIDI THABET",
                "CITE ETHADAMEN",
                "SOUKRA",
                "MNIHLA",
                "RAOUED"
            ],
            "BEN AROUS": [
                "BEN AROUS",
                "RADES",
                "HAMMAM LIF",
                "MORNAG",
                "M'HAMDIA",
                "EZZAHRA",
                "MEGRINE",
                "EL MOUROUJ",
                "BOU MHEL BASSATINE",
                "HAMMAM CHATT",
                "MEDINA JADIDA",
                "FOUCHANA"
            ],
            "MANNOUBA": [
                "MANOUBA",
                "DOUAR HICHER",
                "OUED ELLIL",
                "MORNAGUIA",
                "BORJ EL AMRI",
                "JEDAIDA",
                "TEBOURBA",
                "EL BATAN"
            ],
            "NABEUL": [
                "NABEUL",
                "BENI KHIAR",
                "KORBA",
                "MENZEL TEMIME",
                "KELIBIA",
                "EL HAOUARIA",
                "SOLIMAN",
                "MENZEL BOU ZELFA",
                "GROMBALIA",
                "BOU ARGOUB",
                "HAMMAMET",
                "HAMMAM LAGHZEZ",
                "DAR CHAABANE EL FEHRI",
                "BENI KHALLED",
                "EL MIDA",
                "TAKELSA"
            ],
            "ZAGHOUAN": [
                "ZAGHOUAN",
                "BIR MECHARGA",
                "EL FAHS",
                "NADHOUR",
                "SAOUAF",
                "ZRIBA"
            ],
            "BIZERTE": [
                "BIZERTE NORD",
                "BIZERTE SUD",
                "MENZEL JEMILE",
                "RAS JEBEL",
                "MENZEL BOURGUIBA",
                "GHEZALA",
                "SEJNANE",
                "UTIQUE",
                "MATEUR",
                "JOUMINE",
                "EL ALIA",
                "JARZOUNA",
                "TINJA",
                "GHAR EL MELH"
            ],
            "BEJA": [
                "BEJA NORD",
                "BEJA SUD",
                "NEFZA",
                "AMDOUN",
                "MEDJEZ EL BAB",
                "TESTOUR",
                "TEBOURSOUK",
                "GOUBELLAT",
                "THIBAR"
            ],
            "JENDOUBA": [
                "JENDOUBA",
                "BOU SALEM",
                "GHARDIMAOU",
                "TABARKA",
                "AIN DRAHEM",
                "FERNANA",
                "JENDOUBA NORD",
                "OUED MELIZ",
                "BALTA BOUAOUENE"
            ],
            "LE KEF": [
                "LE KEF EST",
                "NEBEUR",
                "SAKIET SIDI YOUSSEF",
                "TAJEROUINE",
                "KALAAT SENANE",
                "KALAA EL KHASBA",
                "JERISSA",
                "DAHMANI",
                "EL KSOUR",
                "ESSERS",
                "LE KEF OUEST",
                "TOUIREF"
            ],
            "SILIANA": [
                "SILIANA NORD",
                "BOUARADA",
                "GAAFOUR",
                "KRIB",
                "BARGOU",
                "BOU ROUIS",
                "KESRA",
                "MAKTHAR",
                "ERROUHIA",
                "SILIANA SUD",
                "LAROUSSA"
            ],
            "KAIROUAN": [
                "KAIROUAN NORD",
                "KAIROUAN SUD",
                "SBIKHA",
                "EL OUESLATIA",
                "CHBIKA",
                "HAFFOUZ",
                "EL ALAA",
                "SIDI AMOR BOU HAJLA",
                "SIDI ALI BEN NASRALLAH",
                "HAJEB EL AYOUN",
                "CHERARDA",
                "MENZEL MHIRI",
                "AIN JLOULA"
            ],
            "KASSERINE": [
                "KASSERINE NORD",
                "KASSERINE SUD",
                "SBEITLA",
                "SBIBA",
                "JEDLIANE",
                "EL AYOUN",
                "THALA",
                "HIDRA",
                "FOUSSANA",
                "FERIANA",
                "MAJEL BEL ABBES",
                "HASSI FERID",
                "EZZOUHOUR KASSERINE"
            ],
            "SIDI BOUZID": [
                "SIDI BOUZID OUEST",
                "SIDI BOUZID EST",
                "CEBALAT OULED ASKAR",
                "JELMA",
                "OULED HAFFOUZ",
                "ERREGUEB",
                "BIR EL HFAY",
                "SIDI ALI BEN AOUN",
                "MEKNASSY",
                "MENZEL BOUZAYANE",
                "MAZZOUNA",
                "SOUK EJEDID",
                "SAIDA"
            ],
            "SOUSSE": [
                "SOUSSE MEDINA",
                "SOUSSE JAOUHARA",
                "SOUSSE RIADH",
                "MSAKEN",
                "SIDI EL HANI",
                "HAMMAM SOUSSE",
                "KALAA SGHIRA",
                "AKOUDA",
                "KALAA KEBIRA",
                "HERGLA",
                "SIDI BOU ALI",
                "KOUNDAR",
                "ENFIDHA",
                "BOUFICHA",
                "SIDI ABDELHAMID",
                "ZAOUIA-KSIBET-THRAYETTE"
            ],
            "MONASTIR": [
                "MONASTIR",
                "OUARDANINE",
                "JEMMAL",
                "ZERAMDINE",
                "BENI HASSENE",
                "KSIBET EL MEDIOUNI",
                "SAYADA LAMTA BOUHJAR",
                "KSAR HELLAL",
                "MOKNINE",
                "TEBOULBA",
                "BEKALTA",
                "SAHLINE",
                "BEMBLA"
            ],
            "MAHDIA": [
                "MAHDIA",
                "KSOUR ESSAF",
                "CHEBBA",
                "SIDI ALOUANE",
                "BOU MERDES",
                "EL JEM",
                "CHORBANE",
                "SOUASSI",
                "OULED CHAMEKH",
                "HEBIRA",
                "MELLOULECHE"
            ],
            "SFAX": [
                "SFAX MEDINA",
                "SFAX SUD",
                "JEBENIANA",
                "EL HENCHA",
                "MENZEL CHAKER",
                "AGAREB",
                "KERKENAH",
                "BIR ALI BEN KHELIFA",
                "MAHRES",
                "SKHIRA",
                "GHERAIBA",
                "SFAX OUEST",
                "SAKIET EZZIT",
                "SAKIET EDDAYER",
                "EL AMRA",
                "TINA"
            ],
            "GAFSA": [
                "GAFSA NORD",
                "ESSENED",
                "BELKHIR",
                "REDEYEF",
                "METLAOUI",
                "GAFSA SUD",
                "OUM LARAIES",
                "EL GUETAR",
                "MDHILLA",
                "EL KSAR",
                "SIDI AICH",
                "ZANNOUCH"
            ],
            "TOZEUR": [
                "TOZEUR",
                "DEGUECHE",
                "TAMAGHZA",
                "NEFTA",
                "HAZOUA",
                "ELHAMMA-DJERID"
            ],
            "KEBILI": [
                "KEBILI NORD",
                "DOUZ NORD",
                "SOUK EL AHED",
                "FAOUAR",
                "KEBILI SUD",
                "DOUZ SUD"
            ],
            "GABES": [
                "GABES MEDINA",
                "GABES OUEST",
                "METOUIA",
                "EL HAMMA",
                "MENZEL EL HABIB",
                "MATMATA",
                "MARETH",
                "MATMATA NOUVELLE",
                "GHANNOUCH",
                "GABES SUD",
                "DKHILET TOUJANE"
            ],
            "MEDENINE": [
                "MEDENINE NORD",
                "SIDI MAKHLOUF",
                "JERBA AJIM",
                "JERBA HOUMET ESSOUK",
                "JERBA MIDOUN",
                "ZARZIS",
                "BEN GUERDANE",
                "BENI KHEDACH",
                "MEDENINE SUD"
            ],
            "TATAOUINE": [
                "TATAOUINE NORD",
                "GHOMRASSEN",
                "REMADA",
                "DHEHIBA",
                "ESSMAR",
                "BIR LAHMAR",
                "TATAOUINE SUD",
                "BENI MHIRA"
            ]
        }
    }
    return lists;
}

export { localityList }